import React from 'react'

interface GrowthFactorIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const GrowthFactorIcon: React.FC<GrowthFactorIconProps> = ({
  color = 'currentColor',
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Chart line going up */}
    <path
      d="M3 18L8 13L12 17L21 8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Upward arrow */}
    <path
      d="M18 6L21 8L18 10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Base line */}
    <path
      d="M3 18H21"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.3"
    />
  </svg>
)

export default GrowthFactorIcon
